import { useNavigate, useParams } from "react-router-dom";
import { useRealtimeStore } from "../../../../lib/store/Realtime";
import { supabase } from "../../../../lib/supabase/supabaseClient";
import {
	ActivityEntityType,
	ClientEntityType,
	SupabaseTableEnum,
} from "../../../../lib/supabase/supabaseTypes";
import { Logger } from "../../../../lib/logger/Logger";
import { useEffect, useState } from "react";
import { Loading } from "../../../../components/src/animations/loading";
import { useCentralStore } from "../../store/Central";
import { OutlinedInput } from "@mui/material";
import { getClientAvatar } from "./utils";
import { Avatar } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { showNotification } from "../../store/Central/selectors";

export const ChatPage = () => {
	const { clientId } = useParams();
	const { profile } = useCentralStore.getState();
	const [loading, setLoading] = useState(false);
	const [avatar, setAvatar] = useState("");
	const navigate = useNavigate();

	const [client, setClient] = useState<
		| (ClientEntityType & {
				connect_relationships: { shared: ActivityEntityType[] } | null;
		  })
		| null
	>(null);

	const { subscribe, unsubscribe } = useRealtimeStore();

	useEffect(() => {
		subscribe();

		return () => {
			unsubscribe();
		};
	}, []);

	const getClient = async () => {
		setLoading(true);
		if (!clientId) return;
		const { data, error } = await supabase
			.from(SupabaseTableEnum.CLIENTS)
			.select(
				`*, connect_relationships(*, shared(*))`
			)
			.eq("id", clientId)
			.single();

		if (error) {
			Logger.error(error, {}, "Error fetching clients");
			return;
		}

		setClient(data);
		setLoading(false);
	};

	const getAvatar = async () => {
		if (!client?.avatar_path) return;
		const avatar_img = await getClientAvatar(
			client?.avatar_path,
			profile?.organization_id as string
		);
		if (!avatar_img) return;
		setAvatar(avatar_img);
	};

	useEffect(() => {
		getClient();
	}, [clientId]);

	useEffect(() => {
		getAvatar();
	}, [client]);

	if (loading) {
		return (
			<div className="w-full h-screen flex items-center justify-center">
				<Loading />
			</div>
		);
	}

	if (!client?.connect_relationships?.shared) return;

	const addMessageActivity = async (
		connectedOrganizationId: string,
		message: string
	) => {
		Logger.log("addMessageActivity", connectedOrganizationId, message);
		showNotification({
			message: "Die Funktion ist vorübergehend deaktiviert",
			type: "error",
		});
		return;
		if (!profile?.id) {
			Logger.error("No Profile");
			return;
		}
		if (!profile?.organization_id) {
			Logger.error("No Organization");
			return;
		}
/* 		await supabase
			.from("shared")
			.insert({
				shared_with: connectedOrganizationId,
				created_by: profile?.id,
				text: message,
				activity_type: ActivityTypeEnum.MESSAGE_GENERAL,
				created_by_org: profile?.organization_id,
			})
			.select()
			.single(); */

		await getClient();
	};
	const activities = client.connect_relationships.shared;

	activities.sort(
		(a, b) =>
			new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
	);

	return (
		<div className="h-full relative overflow-hidden">
			<div className="flex shadow-md shadow-black/20 items-center gap-2 pb-1 text-lg font-medium">
				<ChevronLeft
					className="cursor-pointer"
					onClick={() => navigate("/chat")}
				/>
				<Avatar
					src={avatar}
					sx={{
						width: "30px",
						height: "30px",
					}}
				/>
				{client.first_name} {client.last_name}
			</div>
			<div className="bottom-0 p-1 absolute bg-white w-full h-12 flex items-center justify-center">
				<OutlinedInput
					placeholder="Neue Nachricht"
					sx={{
						width: "100%",
						height: "40px",
					}}
					onKeyDown={(e) => {
						if (e.key.toLowerCase() === "enter") {
							addMessageActivity(
								client.connected_organization_id as string,
								// @ts-expect-error it exists
								e.target.value as string
							);
						}
					}}
				/>
			</div>
		</div>
	);
};
